import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AppRouter } from './AppRouter';
import { AuthProvider } from './contexts/AuthContext';
import { RentalProvider } from './contexts/RentalContext';
import { TransactionProvider } from './contexts/TransactionContext';
import { AIAssistantChatProvider } from './contexts/AIAssistantChatContext';
// Scroll to top component
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <AuthProvider data-id="element-0">
      <RentalProvider data-id="element-1">
        <TransactionProvider data-id="element-2">
          <AIAssistantChatProvider data-id="element-3">
            <ScrollToTop data-id="element-4" />
            <AppRouter data-id="element-5" />
          </AIAssistantChatProvider>
        </TransactionProvider>
      </RentalProvider>
    </AuthProvider>;
}